import { Component, OnInit, Input, Inject } from '@angular/core';
import { forkJoin } from 'rxjs';
import { PickupHistoryService } from '../../../@core/services/pickup-history.service';
import { ParcelHistoryService } from '../../../@core/services/parcel-history.service';
import { StopService } from '../../../@core/services/stop.service';
import { PickupHistories } from '../../../@core/models/pickup-histories';
import { LiveRouteStatus } from '../../../@core/models/live-route-status';
import { ParcelHistories } from '../../../@core/models/parcel-histories';
import { LiveRouteType } from '../../../@core/models/live-route-type';
import { TranslateService } from '@ngx-translate/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiProvider } from '../../../@core/providers/api.provider';
import { DatePipe } from '@angular/common';
import { AuthenticationService } from '../../../@core/services/authentication.service';
import { Stop } from '../../../@core/models/live-route';
import { ENotificationType } from '../../../@core/models/e-notification-type';

@Component({
  selector: 'ngx-add-exception-dialog',
  templateUrl: './add-exception-dialog.component.html',
  styleUrls: ['./add-exception-dialog.component.scss']
})
export class AddExceptionDialogComponent implements OnInit {
  public selectedExceptionId: number = 0;
  public selectedSubExceptionId5: number = 0;
  public selectedSubExceptionId40: number = 0;
  public selectedSubExceptionId44: number = 0;
  public reason: string = '';
  public visitCode: string = '';
  public contact: string = '';
  public displaySendBtn: boolean = false;
  public selectedStops: Stop[];
  public submitted: boolean = false;

  //Vive ionic
  public ionDateString: string;
  public ionExceptionDateString: string;
  public ionDatelivString: string;
  public maxDateTimeString: string;
  public todayString: string;
  public nextBusinessDay: Date;
  public minDate: Date = new Date();
  public maxDate: Date = new Date();

  constructor(
    public apiProvider: ApiProvider,
    public _stopService: StopService,
    private datePipe: DatePipe,
    public authenticationService: AuthenticationService,
    public dialogRef: MatDialogRef<AddExceptionDialogComponent>,
    private translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}
  ngOnInit() {
    this.maxDateTimeString = this.datePipe.transform(
      new Date(),
      'yyyy-MM-ddTHH:mm'
    );

    const moment = require('moment-business-days');
    this.nextBusinessDay = moment().nextBusinessDay().startOf('day').toDate();
    this.todayString = this.nextBusinessDay.toISOString();
    this.ionExceptionDateString = this.datePipe.transform(
      new Date(),
      'yyyy-MM-dd'
    );
    this.ionDatelivString = this.datePipe.transform(
      new Date(),
      'yyyy-MM-ddTHH:mm'
    );
    /*if (this.nextBusinessDay.getDay() == 5) {
      this.nextBusinessDay.setDate(this.nextBusinessDay.getDate() + 3);
      this.ionDateString = this.nextBusinessDay.toISOString();
    } else {
      this.nextBusinessDay.setDate(this.nextBusinessDay.getDate() + 1);
      this.ionDateString = this.nextBusinessDay.toISOString();
    }*/
    this.ionDateString = this.nextBusinessDay.toISOString();
    if (
      this.data &&
      this.data.nonCompletedStops &&
      this.data.nonCompletedStops.length > 0
    ) {
      this.selectedStops = this.data.nonCompletedStops;
    } else {
      this.selectedStops = this._stopService.selectedStops;
    }
    //this.setSelected(true);
  }
  /*
  public setSelected(checked: boolean): void {
    this._stopService.selectedStopsAllowedException.forEach((item) =>
      item.ParcelCompress.forEach((x) => (x.IsSelected = checked))
    );
  }
*/
  public goBack(): void {
    this.dialogRef.close(false);
  }

  public getDisplayCode40SubExceptionsClass(): string {
    if (this.canDisplayCode40SubException()) {
      return '';
    } else {
      this.selectedSubExceptionId40 = 0;
      return 'invisible';
    }
  }

  private canDisplayCode40SubException() {
    return this.selectedExceptionId == 40;
  }

  public getDisplayCode5SubExceptionsClass(): string {
    if (this.canDisplayCode5SubExceptions()) {
      return '';
    } else {
      this.selectedSubExceptionId5 = 0;
      return 'invisible';
    }
  }

  private canDisplayCode5SubExceptions() {
    return this.selectedExceptionId == 5;
  }

  public getDisplayReasonClass(): string {
    if (this.canDisplayReason()) {
      return '';
    } else {
      this.reason = '';
      return 'invisible';
    }
  }

  public canDisplayReason() {
    return (
      this.selectedExceptionId == 3 ||
      this.selectedSubExceptionId40 == 400 ||
      this.selectedSubExceptionId5 == 302 ||
      this.selectedExceptionId == 75
    );
  }

  public getDisplayContactClass(): string {
    if (this.canDisplayContact()) {
      return '';
    } else {
      this.contact = '';
      return 'invisible';
    }
  }

  public canDisplayContact() {
    return this.selectedExceptionId == 4 || this.selectedExceptionId == 119;
  }

  public getDisplayDatelivDateClass() {
    if (this.canDisplayDatelivDate()) {
      return '';
    } else {
      return 'invisible';
    }
  }

  public getDisplayPostponedDateClass() {
    if (this.canDisplayPostponedDate()) {
      return '';
    } else {
      return 'invisible';
    }
  }

  public canDisplayPostponedDate() {
    return this.selectedSubExceptionId5 == 200 || this.selectedExceptionId == 9 || this.selectedExceptionId == 75;
  }

  public canDisplayDatelivDate() {
    return this.selectedExceptionId == 119 ||
      (this.authenticationService.currentUserValue &&
        this.authenticationService.currentUserValue.AdminTPSLRoute)
      ? this.authenticationService.currentUserValue.AdminTPSLRoute
      : false;
  }

  private displayDoneButton(): void {
    if (this.selectedExceptionId == 0) {
      this.displaySendBtn = false;
    } else if (
      this.canDisplayCode40SubException() &&
      this.selectedSubExceptionId40 == 0
    ) {
      this.displaySendBtn = false;
    } else if (
      this.canDisplayCode5SubExceptions() &&
      this.selectedSubExceptionId5 == 0
    ) {
      this.displaySendBtn = false;
    } else if (this.canDisplayContact() && this.contact.length < 2) {
      this.displaySendBtn = false;
    } else if (this.canDisplayReason() && this.reason.length < 2) {
      this.displaySendBtn = false;
    } else {
      this.displaySendBtn = true;
    }
  }

  public anyFieldChange(): void {
    this.displayDoneButton();
  }

  public sendClick(): void {
    // this.functionModule.startWaiting();
    this.submitted = true;
    const parcelHistories = this.getParcelHistories();
    const insertParcelHistories =
      this.apiProvider.insertParcelHistories(parcelHistories);
    let changeLiveRouteStatus = 3;
    if (this.selectedExceptionId == 119) {
      changeLiveRouteStatus = 4;
    }
    insertParcelHistories.subscribe((results) => {
      if (this.data === null) {
        parcelHistories.ParcelIDs.forEach((x) =>
          this._stopService.ChangeParcelStatus(x, changeLiveRouteStatus)
        );
      }
      // this.functionModule.stopWaiting();
      this.selectedStops.forEach(
        (x) => (x.Max_Live_Route_Status = changeLiveRouteStatus)
      );
      this.selectedStops.forEach(
        (x) => (x.Min_Live_Route_Status = changeLiveRouteStatus)
      );

      this.sendUpdateNotification()
      this.dialogRef.close(false);
    });
  }

  public getParcelHistories(): ParcelHistories {
    const parcelIds: number[] = [];
    this.selectedStops.filter((x) =>
      x.ParcelCompress.filter(
        (y) => y.Live_Route_Status <= LiveRouteStatus.InRoute
      ).forEach((z) => parcelIds.push(z.Parcel_ID))
    );
    const parcelHistories = new ParcelHistories();
    parcelHistories.ParcelIDs = parcelIds;
    parcelHistories.PostponedDate;
    parcelHistories.ExceptionID = Number(this.selectedExceptionId);
    if (this.canDisplayDatelivDate())
      parcelHistories.ProcessedDate = this.ionDatelivString;
    else
      parcelHistories.ProcessedDate = this.datePipe.transform(
        new Date(),
        'yyyy-MM-dd HH:mm:ss a'
      );
    parcelHistories.SubExceptionID = 0;
    parcelHistories.TPSL = this._stopService.RouteID
    if (this.selectedExceptionId == 119)
      parcelHistories.TPSL = this._stopService.RouteID;

    parcelHistories.UserID = this.authenticationService.currentUserValue.UserID;
    parcelHistories.Contact = this.contact;
    parcelHistories.SourceType = 401;
    if (this.canDisplayPostponedDate()) {
      parcelHistories.PostponedDate = this.datePipe.transform(
        new Date(this.ionDateString),
        'yyyy-MM-dd'
      );
    }
    if (Number(this.selectedSubExceptionId5) > 0) {
      parcelHistories.SubExceptionID = Number(this.selectedSubExceptionId5);
    }
    if (Number(this.selectedSubExceptionId40) > 0) {
      parcelHistories.SubExceptionID = Number(this.selectedSubExceptionId40);
    }
    if (Number(this.selectedSubExceptionId44) > 0) {
      parcelHistories.SubExceptionID = Number(this.selectedSubExceptionId44);
    }
    parcelHistories.Reason = this.reason;
    if (this.visitCode.length > 0) {
      parcelHistories.VisitCode = Number(this.visitCode);
    }
    return parcelHistories;
  }

  public sendUpdateNotification(){
    this.apiProvider.sendNotification("Mobile", ENotificationType.update, this._stopService.RouteID).subscribe(
      (res) => {
      },
      (err) => {
      }
    )
  }

}
